export default "__VITE_ASSET__f9$rDhix__"